import { render, staticRenderFns } from "./LoggedHome.vue?vue&type=template&id=13ffc599&scoped=true"
import script from "./LoggedHome.vue?vue&type=script&lang=js"
export * from "./LoggedHome.vue?vue&type=script&lang=js"
import style0 from "./LoggedHome.vue?vue&type=style&index=0&id=13ffc599&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ffc599",
  null
  
)

export default component.exports